import { useMutation, useQueryClient } from '@tanstack/react-query';
import { makeBackendApi } from 'services/BackendApi';
import { enqueueNotification } from 'store/modules/ui';
import { useDispatch } from 'react-redux';
import { CONVERSION_RATES_QUERY_KEY } from './useConversionRatesQueries';

export const useDeleteConversionRate = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ from, to }: { from: string; to: string }) => {
      const api = makeBackendApi();
      await api.deleteSystemExchangeRate(from, to);
    },
    onSuccess: () => {
      dispatch(
        enqueueNotification({
          message: 'Conversion rate deleted successfully',
          options: { variant: 'success' },
        })
      );
      // Invalidate conversion rates query to refetch the list
      queryClient.invalidateQueries({
        queryKey: [CONVERSION_RATES_QUERY_KEY],
      });
    },
    onError: () => {
      dispatch(
        enqueueNotification({
          message: 'Failed to delete conversion rate',
          options: { variant: 'error' },
        })
      );
    },
  });
};

